import React from "react";
import { Box, useTheme } from "@mui/material";
import SMButtonBrown from "./SMButtonBrown";

const HorizontalPillMenu = ({
                                items = [],
                                value,
                                onChange,
                                sx,
                                buttonSx,
                            }) => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                ...sx,
            }}
        >
            <Box
                sx={{
                    display: { xs: "grid", sm: "flex" },
                    gridTemplateColumns: { xs: "repeat(2, 1fr)" },
                    gap: { xs: 1.5, sm: 1, md: 2 },
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                {items.map((item) => {
                    const isActive = item.value === value;

                    return (
                        <SMButtonBrown
                            key={item.value}
                            to={item.to}
                            fullWidth
                            onClick={() => onChange?.(item.value, item)}
                            sx={{
                                fontSize: 16,
                                minWidth: { xs: 180, sm: 140, md: 180, lg: 180, xl: 180 },

                                ...(isActive && {
                                    backgroundColor: theme.palette.primary.main,
                                    color: "#ffffff",
                                }),

                                ...buttonSx,
                            }}
                        >
                            {item.label}
                        </SMButtonBrown>
                    );
                })}
            </Box>
        </Box>
    );
};

export default HorizontalPillMenu;
